module.exports = "<p>\n  propertiesregister works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/propertiesregister/propertiesregister.component.html
// module id = ./src/app/planning/propertiesregister/propertiesregister.component.html
// module chunks = main